<template>
  <div class="mx-auto my-10 max-w-lg">
    <div class="bg-white overflow-hidden shadow rounded-lg mt-10">
      <div class="border-b border-gray-200 px-4 py-5 sm:px-6">
        <h1>COD Order confirmation</h1>
      </div>
      <div class="px-4 py-5 sm:p-6">
        <div class="mt-2 mb-6 max-w-xl text-sm leading-5 text-gray-500">
          With this feature you could send messages to your customers who
          chooses COD payment automatically
        </div>
      </div>
      <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <div class="sm:flex sm:items-end sm:justify-end">
            <div
              class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
            >
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                  @click="enable"
                  :disabled="isEnabling"
                >
                  Enable
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CODVerificationOnboarding",
  data() {
    return {
      isEnabling: false
    };
  },
  methods: {
    enable() {
      this.isEnabling = true;
      this.$store
        .dispatch("enableCodVerification")
        .then(response => {
          if (response.authUrl) {
            if (window.top) {
              window.top.location = response.authUrl;
            } else {
              window.location.href = response.authUrl;
            }
          }
          return this.$store.dispatch("getConfig");
        })
        .then(() => {
          this.isEnabling = false;
        })
        .catch(() => {
          this.isEnabling = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
